<template>
<div class="next">
	<div class="van-nav-bar van-hairline--bottom">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback" @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{xuanfeidata.xuanfei_name}}
			</div>
			<div class="van-nav-bar__right van-haptics-feedback"  @click="toService">
				<i class="van-badge__wrapper van-icon" style="font-size: 24px;">
					
					<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA4BJREFUWEfFlmnIpnMUxn/XF75Z840SgxAa2xiRJRnLkMlS82WSqcE09hBlnQxNQsaSyZJMmozsJNuMhvggGmQJKVtRJqbIJ5eux7nf7nk9z/vc91OaU/+e5f6fc677LNc5YhuLtrF/egGwfShwJHAIcHCdn4GP62yS9Gyfl+oEwPZuwBXAlcD2YxxsAO6W9EIXIGMB2F5ajvcGvgFWA1/X+QrYBdgHmAUcBSwux2uAFZI+nwnIjADK+f1l4AHgNkk/5bftHYH9gM2SAmggtk8DrgJOBD4C5jc6w4CMBGB7PvBiKS2UtNb2/sAlwEn11o3NP4EvgbWSVhaQO4BrgbeAMyX90RmA7YOAl4E9gBuB24Gby/kOY3L7LrAyNWB7HXAO8LSkc/sAWAFcBzwCXA88BiS0fWQJ8BLwanXLsZLemW5gaApsp3BSVGm1J4DD+nhu3b2hvi8H7pV02VgAts8C0svPAd8Bl07ovFGbC7wH5KXmSfq+be8/EbD9OLAIOBl4rafz5Hx6rp8EUjcp6oeBN1PQjd0pALbTz6n6o+thcndKTwDhgLTmNdP0Qk7Ht/7bSdLv+d0GcH4VW0+fU9fTiscACXGKLUBGyS2S0lVbAbipWm0SAJuB5ZLuKQ64PHT8fwLIAPqwdTZICoiB2J5dz3pFICFJFEbJRiD8PnAs6e+ZQmU7zLjviDtDUzATgCmFrvmxvQpY1gdAmOuhEQonSEoldxbbd9ZQis6WasVGfzBbphfhnsC3deOvotCQUmRnSb919v5vHYTGLyid04vQ5gHrJJ3X2BpGROnlp4A5wOt1cYGkMGNnsf0MsAB4VNJi2xcDtwKzJf0wEkDbg+0HgYuAsTVg+wDgQElhw0RgfZwBGUKf2P4iRCfp6raPLhvRL7WGzZX0Wct4IrKpjIV+TwWOC9fb3qu2pwHw2i0yX/L2n/YCUA7TnnMkTY1k2/nvDGBXIC2aZeSVup/8r5e0xvbuwPPAG5KyoGwlYyPQ3LadbTgg0l4jxXYKeZGkjba3q8Vmi6Szhyl1BtACMqu9A45CYjtrW0Z5tqq08dAu6g2gBSS8sRB4uxksFf7M/zzLKnZfjqQfRwGdCIDtbEgftIzeBRwOHAH8WqvYqqZoZ0rZpAAy29NmjaT1svW8LymfnWUiABXq0HZCvVrShZ09TtoFkzoYpzdxBMYZ7vr8HyNeRjAaHC/gAAAAElFTkSuQmCC">
					</i>
			</div>
		</div>
	</div>
	<div class="swiper">
		<swiper class="swiper" :options="bannerSwiperOption">
		  <swiper-slide v-for="(v,key) in xuanfeidata.img_url" :key="key">
				<img class="banner_img"  :src="v" />
				<span>
					<i>
						{{$t('home.gaoji')}}
					</i>
				</span>
		  </swiper-slide>
		</swiper>
	  <div class="swiper-fot">
	  	<i class="van-badge__wrapper van-icon" style="font-size: 81px;">
	  		<img class="van-icon__image" src="img/logo.png">
		</i>
	  	<div class="v">
	  		<span>
	  			<i class="van-badge__wrapper van-icon">						
	  				<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC">
	  				</i>
	  			{{$t('home.smrz')}}
	  		</span>
	  		<span>
	  			<i class="van-badge__wrapper van-icon">						
	  				<img class="van-icon__image" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy9JREFUWEfdlk1IVFEUx//nOfaxKVpEgcsWSh/gwr5oUUb0tYjAdDFvtBZR2dyRgqLSeYPNGzWCEHxvJFplzhtBJXCVFfS1CCsjCGzRxz4K3LUp5514b7RGe3fem7EQust3zrn/3zn3nPsuYYkXLbE+lh5gUBd7yq1Cs2Y+WRhb6n7kBCjAPQArSgD5ZAMnZQAK8DjIXjZQ7x5Bpju2kXI8DGCTXyAzn18WUqymduOrzHe4O7Z2xuZGZqQ9fD7YNrLLubKvqbN3el4PWLr4DGBdMQiH2itzrxhLFx8BbCi0MehARDMezH2bD9B1tha28qYYAIFvhLX0Bb9KOXZLF9MA1sz5MtAT0cz2wtg/piCTjJ4jol6pAOO9mjCr/QCGktHtNtHE70xpPKwZhxbGeY6hpYvnAHbKRHLMO1oS6RfFILJ67CKDr//yYaVOTfS9DgaQiqlgzhQR6FQ182pxgOgIg465PoRbatw87eUvvYgsXdwHsN8ziDAZjptbZQDZblFj5/CWgErXR5J9nk2yhnRxxAbGZHYiPhGOpwe87BldpAjo8Mu+KIBjzKbEKDMaJBDPVM3cvdA2fO3S6pkf36YYqPLL3hfA6mqrh20/kp41oUmNmyOFdisZEyA2gmTvC+A4ZHRxm4DjXhAMHo9o6XmjZenCuUdqg2QfCGAoJepsxktpvyg4qHaYTsM6R9bAjNGg2QcCcJyspDBAEJKjuKtqptsnhZPDbG+LJPpfSY9v1hDoPZDtFDVcAefiWeW1oU32LgUUAtPTfPY0psaNo37igSvgllcX3Qxc8e4FDBA4BJDq2G2icHPcGPqrAAOpM1UVHJokYL3PxlPhuLGFiPivArgTkRQ9RLjss3FC1Uw9iHhJR+A4D+qt1QoqnDFbKRH4DiibVa3vwz8ByHd6tB+gVonAHVUzPe8MGVCgKSgMtlKxbWD2/BWzgsORDtN5XwZeJQPkqxDLAOx2/Nwi8POwlt4VWHnWsVyAfQA/nA+AtrBm5v8BJayyAPJVEM4runFWayqXm9nb0nnzSwnarmvZAC5EMnqKocwghIlIu/GuVPFFA5QjuDBmURX4LwB+Ajq/G9S6JXoiAAAAAElFTkSuQmCC">
	  				</i>
	  			{{$t('home.videorz')}}
	  		</span>
	  	</div>
	  </div>
	</div>
	
	<h1 style="font-size: 18px; padding: 14px 0px; color: rgb(255, 255, 255); background-image: linear-gradient(-244deg, rgb(184, 203, 184) 0%, rgb(184, 203, 184) 0%, rgb(180, 101, 218) 0%, rgb(207, 108, 201) 33%, rgb(238, 96, 156) 66%, rgb(238, 96, 156) 100%);">
		{{xuanfeidata.xuanfei_name}}
		<span style="margin-left: 10px; font-size: 16px;">
			{{xuanfeidata.sn}}
		</span>
	</h1>
	<div class="sm">
		<div class="lef">
			<h1 class="title" style="padding: 0px 0px 10px;">
				{{$t('choose.jianjie')}}
			</h1>
			<p>
				{{$t('home.sg')}}: {{xuanfeidata.sg}}cm {{$t('home.xw')}}：{{xuanfeidata.xw}}
			</p>
			<div class="tips">
				<span v-for="(val,index) in xuanfeidata.tags_arr" :key="index"  >
					{{val}}
				</span>
			</div>
			<p class="sf">
				{{$t('home.star')}}：
				<span v-for="(numa,indexs) in xuanfeidata.star" :key="indexs" ></span>
			</p>
			<p>
				{{$t('home.diqu')}}：{{xuanfeidata.class_name}}
			</p>
			<p>
				{{$t('choose.move')}}：{{$t('possible')}}
			</p>
		</div>
		<div class="right">
			<img src="img/zan.c28032c8.png" alt="">
			<span>
				{{$t('thumb')}}
			</span>
		</div>
		<a @click="show=true">
			{{$t('choose.click')}}
		</a>
	</div>
	<div class="foot" style="position: relative;display: block;">
		<h1>
			{{$t('choose.detail')}}
		</h1>
		<ul>
			<li  v-for="(v,key) in xuanfeidata.img_url" :key="key">
				<img :src="v" alt="">
			</li>			
		</ul>
		<h1 style="padding-bottom: 0px;">
			{{$t('choose.videodetail')}}
		</h1>
		<div  style="padding-top: 10px;">
			<!-- <d-player ref="player" id="player" @play="handlePlay" @pause="handlePause" :options="options"></d-player> -->
		  <video width="100%"  controls :src="xuanfeidata.video_url"></video>
			
		</div>
	</div>

	<div class="jianjie" id="jianjie">
		<h2>
			{{$t('privacyPolicy')}}
		</h2>
		<p>
			{{$t('romanticDescription')}}
		</p>
	</div>
	<van-popup
	  v-model="show"
	  closeable
	  close-icon="close"
	  get-container="#app"
	  :style="{ height:'88%',width:'90%' }"
	>
		<Game :pkey="xuanfeidata.lottery.key" :pid="xuanfeidata.lottery.id" :ppic="xuanfeidata.img_url[0]"/>
	</van-popup>
</div>
</template>

<script>
import Game from '../../common/Game'
// import DPlayer from "dplayer";
export default {
	components: {
	  Game
	},
	data() {
		return {
			xuanfeidata: [],
			show:false,
			nowPlayVideoUrl:'',
			cover:"",
			player:null,
			bannerSwiperOption: {
			  loop: true,
			  speed:1000,
			  autoplay:true,
			  pagination: {
			    el: '.swiper-pagination'
			  },
			},
			options: {
			  container: document.getElementById("dplayer"), //播放器容器
			  mutex: false, //  防止同时播放多个用户，在该用户开始播放时暂停其他用户
			  theme: "#b7daff", // 风格颜色，例如播放条，音量条的颜色
			  loop: false, // 是否自动循环
				autoplay:false,
			  lang: "zh-cn", // 语言，'en', 'zh-cn', 'zh-tw'
			  screenshot: true, // 是否允许截图（按钮），点击可以自动将截图下载到本地
			  hotkey: true, // 是否支持热键，调节音量，播放，暂停等
			  preload: "auto", // 自动预加载
			  volume: 0.7, // 初始化音量
			  playbackSpeed: [0.5, 0.75, 1, 1.25, 1.5, 2, 3], //可选的播放速度，可自定义
			  logo:"", // 在视频左上角上打一个logo
			  video: {
			    url:'', // 播放视频的路径
			    pic:"",
			    thumbnails:"https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=24336452,906724543&fm=26&gp=0.jpg" // 进度条上的缩略图,需要通过dplayer-thumbnails来生成
			  },
			}
		};
	},
	methods: {
		handlePlay(){
		  console.log('播放');
		  this.is_zz=true
		},
		handlePause(){
		  console.log('暂停');
		},
		back(){
		  return window.history.back();
		},
		toService(){
		  if(this.$store.getters.getBaseInfo.iskefu == 1){
		    this.$router.push("ServiceOnline");
		  }else {
		    this.$toast.fail(this.$t('common.noallow'));
		  }
		},
		getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.xuanfeidata = res.data;
				// console.log(this.xuanfeidata)
				this.cover = res.data.cover;
				// this.options.video.pic = this.cover;
				// this.options.video.url = this.xuanfeidata.video_url;
				// new DPlayer(this.options);
				// console.log(this.options.video.url)
				// let videos = document.getElementById('my-video');
				// videos.poster = this.cover;

			});
		},
		yuyue() {
			this.$toast('请联系顾问或接待员');
		}
	},
	created() {
		if(!localStorage.getItem('token')){
		  this.$router.push({path:'/Login'})
		}
		this.getxuanfeidata();
		this.videoPlayer = this.$el.querySelector('video');
	},
	destroyed () {
	  this.player.dispose()
	}
};
</script>

<style>
video {
    width: 100%
}

:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}
.next .van-nav-bar {
    z-index: 999;
	position: relative;
    background: url(/img/header.svg) no-repeat 50%/100%;
}
.van-nav-bar__content{
	height:3rem;
}
.lottery {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: url(/img/233.png) no-repeat top/100%;
    position: absolute
}

.lottery .van-nav-bar {
    background: linear-gradient(90deg,rgba(223,53,173,.8),rgba(79,29,181,.8))
}

.lottery .van-hairline--bottom:after {
    border: none
}

.lottery .van-nav-bar__text {
    color: #fff
}

.lottery .order {
    width: 80%;
    border-radius: .33333rem
}

.lottery .order .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .5rem 5%;
    border-bottom: 1px solid #f7f8f9;
    background: linear-gradient(20deg,#a253d0,#d63f8c)
}

.lottery .order .title span {
    color: #fff;
    font-size: 1.03333rem
}

.lottery .order .title i {
    font-size: 1.33333rem;
    color: #fff
}

.lottery .order .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: .66667rem 5%;
    border-bottom: 1px solid #f7f8f9
}

.lottery .order .content>div {
    text-align: left
}

.lottery .order .content>div span {
    color: #f6379c;
    font-size: .8rem;
    text-align: left;
    display: inline-block;
    padding: .33333rem 0
}

.lottery .order .content>div p {
    color: #5739ab;
    font-size: .86667rem
}

.lottery .order .content>span {
    display: flex;
    width: 1.2rem;
    height: 1.33333rem;
    background: #f6379c;
    border-radius: .2rem;
    position: relative
}

.lottery .order .content>span:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 90%;
    height: .13333rem;
    background: #fff;
    margin: auto
}

.lottery .order .btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 50% 5% 5%
}

.lottery .order .btn a {
    border: 1px solid #979799;
    color: #979799;
    font-size: .8rem;
    padding: .53333rem 1.66667rem;
    border-radius: 3.33333rem
}

.lottery .order .btn a:last-child {
    background: linear-gradient(30deg,#7d76ef,#d63f8c);
    color: #fff;
    border: none
}

.lottery .mask {
    position: absolute;
    bottom: 0;
    min-height: 9rem;
    width: 100%;
    background: #fff;
    box-shadow: 0 -.13333rem .13333rem rgba(0,0,0,.07);
    padding: 0 3%
}

.lottery .mask .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .33333rem 0
}

.lottery .mask .title p {
    color: #3b3597
}

.lottery .mask .title span {
    color: #ed37ae;
    font-size: .86667rem
}

.lottery .mask .title>div i {
    color: #ff253f;
    font-size: .86667rem
}

.lottery .mask .title>div i:first-child {
    position: relative;
    left: .6rem
}

.lottery .mask .c1 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: .33333rem 0;
    color: #3b3597
}

.lottery .mask .c1 input {
    text-align: center;
    border: 0;
    background: #f2f2f5;
    padding: .33333rem 0;
    margin: 0 .33333rem;
    width: 8.33333rem
}

.lottery .mask .c1 span {
    min-width: 6.66667rem
}

.lottery .mask .c2 {
    border-top: 1px solid #f7f8f9;
    padding: .33333rem 0;
    margin-top: 0
}

.lottery .mask .c2 p {
    text-align: left;
    color: #3d359c
}

.lottery .mask .c2 p span {
    color: #ed50b2;
    padding: 0 .33333rem
}

.lottery .mask .c2 .cm {
    display: flex;
    justify-content: space-between;
    padding: .66667rem 0
}

.lottery .mask .c2 .cm>div {
    width: 16.666%;
    height: 2.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #a063ee;
    background: url(data:image/png;base64,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) no-repeat 50% 50%/auto 100%
}

.lottery .mask .c2 .cm>div.active {
    color: #fff;
    background: url(data:image/png;base64,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) no-repeat 50%/auto 100%
}

@keyframes moves-fa29cd70 {
    0% {
        opacity: 0
    }

    to {
        opacity: 1
    }
}

.lottery .foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 3.2rem;
    background: #fff;
    padding: 0 3%;
    display: flex;
    justify-content: flex-end;
    align-items: center
}

.lottery .foot p {
    padding-right: .66667rem;
    font-size: .86667rem;
    color: #302697
}

.lottery .foot p span {
    color: #ef41b1;
    padding: 0 .33333rem
}

.lottery .foot a {
    background: linear-gradient(20deg,#8673e5,#d958a4);
    color: #fff;
    border-radius: .33333rem;
    padding: .53333rem 1.33333rem;
    font-size: 1rem
}

.lottery .van-nav-bar {
    width: 100%
}

.lottery .top {
    width: 100%;
    padding: 1rem .66667rem .66667rem;
    position: relative;
    z-index: 10;
    background: linear-gradient(90deg,rgba(223,53,173,.8),rgba(79,29,181,.8))
}

.lottery .top .qs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: .46667rem
}

.lottery .top .qs>span {
    color: #f4d70a;
    font-size: 1.13333rem
}

.lottery .top .qs>div {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.lottery .top .qs>div h1 {
    font-size: .96667rem;
    color: #fff;
    padding-left: .66667rem
}

.lottery .top .qs>div .ico {
    width: 3.33333rem;
    height: 3.33333rem;
    overflow: hidden
}

.lottery .top .qs>div .ico img {
    width: 100%
}

.lottery .top .number {
    padding: .66667rem .66667rem;
    background: #f47cd5
}

.lottery .top .number .right,.lottery .top .number {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: .26667rem
}

.lottery .top .number .right {
    width: 60%;
    background: #fff;
    height: 2.66667rem;
    padding: 0 .66667rem;
    position: relative
}

.lottery .top .number .right:before {
    content: "";
    position: absolute;
    left: -1rem;
    width: 2PX;
    height: 2rem;
    background: #f9b1e7
}

.lottery .top .number .right .res {
    display: flex;
    justify-content: center;
    align-items: center
}

.lottery .top .number .right .res span {
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: #fff;
    margin-right: .86667rem;
    background: linear-gradient(90deg,#8b73e6,#d75db4)
}

.lottery .top .number .left {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.lottery .top .number .left .res {
    width: 6.66667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: .33333rem
}

.lottery .top .number .left .res span {
    font-size: .93333rem;
    font-weight: 600
}

.lottery .top .number .left .ball,.lottery .top .number .left .ball p {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.lottery .top .number .left .ball p {
    height: 1.8rem;
    width: 6.93333rem;
    font-size: .8rem;
    color: #fff;
    font-weight: 600
}

.lottery .top .number .left .ball span {
    width: 2.33333rem;
    height: 2.33333rem
}

.lottery .top .number .left .ball span.idem4 {
    background: url(/img/4.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem1 {
    background: url(/img/1.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem2 {
    background: url(/img/2.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem3 {
    background: url(/img/3.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem5 {
    background: url(/img/5.png) no-repeat 50%/100%
}

.lottery .top .number .left .ball span.idem6 {
    background: url(/img/6.png) no-repeat 50%/100%
}

.lottery .history {
    position: absolute;
    width: 100%;
    height: calc(100% - 9.6rem);
    background: rgba(0,0,0,.2);
    z-index: 9;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start
}

.lottery .history>div {
    overflow-y: auto;
    width: 100%;
    height: 20rem;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: .66667rem
}

.lottery .history>div>div p {
    font-size: .76667rem;
    font-weight: 600
}

.lottery .history>div>div ul {
    width: 100%;
    padding-top: .66667rem
}

.lottery .history>div>div ul li {
    width: 100%;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center
}

.lottery .history>div .left {
    width: 7.33333rem
}

.lottery .history>div .right {
    flex: 1;
    background: #fff
}

.lottery .history>div .right ul li .res {
    width: 6.66667rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 1.33333rem
}

.lottery .history>div .right ul li .res span {
    font-size: .8rem;
    font-weight: 600;
    background: linear-gradient(90deg,#f560cd,#4f2b8a);
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 1.66667rem;
    height: 1.66667rem
}

.lottery .history>div .right ul li .ball {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.lottery .history>div .right ul li .ball p {
    height: 1.8rem;
    width: 6.93333rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: .76667rem;
    color: #9b9a9a
}

.lottery .history>div .right ul li .ball span {
    width: 1.8rem;
    height: 1.8rem;
    margin-right: .5rem
}

.lottery .history>div .right ul li .ball span.idem4 {
    background: url(/img/4.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem1 {
    background: url(/img/1.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem2 {
    background: url(/img/2.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem3 {
    background: url(/img/3.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem5 {
    background: url(/img/5.png) no-repeat 50%/100%
}

.lottery .history>div .right ul li .ball span.idem6 {
    background: url(/img/6.png) no-repeat 50%/100%
}

.lottery .lottery-content {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: #f0f0f0;
    overflow: hidden
}

.lottery .lottery-content .left {
    width: 6.06667rem;
    height: 100%;
    background: #fff;
    padding-top: 1rem;
    border-top: 1rem solid #f0f0f0;
    display: none
}

.lottery .lottery-content .left .item {
    width: 100%
}

.lottery .lottery-content .left .item:first-child span {
    border-radius: 0 .33333rem 0 0
}

.lottery .lottery-content .left .item span {
    width: 100%;
    background: #f3cb76;
    color: #fff;
    display: inline-block;
    font-size: .83333rem;
    padding: .66667rem 0
}

.lottery .lottery-content .left .item>.slide {
    padding: 1rem 0;
    background: #fff
}

.lottery .lottery-content .left .item>.slide.active {
    background: #ece6eb;
    color: #7e5678;
    position: relative;
    overflow: hidden
}

.lottery .lottery-content .left .item>.slide.active:after {
    content: "";
    position: absolute;
    width: 1rem;
    height: 1rem;
    right: -.66667rem;
    top: 0;
    bottom: 0;
    margin: auto;
    background: #fff;
    transform: rotate(50deg)
}

.lottery .lottery-content .right {
    flex: 1;
    height: 100%;
    overflow-y: auto
}

.lottery .lottery-content .right .ball {
    align-items: center;
    padding: 5% 5% 4rem;
    position: relative
}

.lottery .lottery-content .right .ball>div,.lottery .lottery-content .right .ball {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap
}

.lottery .lottery-content .right .ball>div .idx0 {
    width: 46%;
    height: 5.2rem;
    background: #fff;
    border-radius: .33333rem;
    margin-bottom: 5%;
    box-shadow: 0 0 .33333rem rgba(0,0,0,.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative
}

.lottery .lottery-content .right .ball>div .idx0.active {
    background: #d07ac7
}

.lottery .lottery-content .right .ball>div .idx0.active:after {
    opacity: .2
}

.lottery .lottery-content .right .ball>div .idx0.active p,.lottery .lottery-content .right .ball>div .idx0.active span {
    position: relative;
    z-index: 99;
    color: #fff
}

.lottery .lottery-content .right .ball>div .idx0 p {
    color: rgba(255,37,63,.9);
    font-size: 1.16667rem;
    font-weight: 600
}

.lottery .lottery-content .right .ball>div .idx0 span {
    color: #ff253f;
    font-size: .76667rem;
    padding-top: .66667rem
}

.lottery .lottery-content .right .ball .idx1 {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    padding-top: 1.33333rem
}

.lottery .lottery-content .right .ball .idx1.ebth {
    display: flex;
    flex-direction: column;
    padding-top: 0
}

.lottery .lottery-content .right .ball .idx1.ebth>div {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    position: relative;
    padding-top: 2rem;
    padding-bottom: .66667rem
}

.lottery .lottery-content .right .ball .idx1.ebth>div>div {
    width: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 5%
}

.lottery .lottery-content .right .ball .idx1.ebth>div>div.active p {
    background: #d07ac7;
    color: #fff
}

.lottery .lottery-content .right .ball .idx1.ebth>div>span {
    position: absolute;
    top: 0;
    left: 0;
    color: #b4b4b5
}

.lottery .lottery-content .right .ball .idx1>span {
    position: absolute;
    top: .66667rem;
    left: .66667rem;
    color: #b4b4b5
}

.lottery .lottery-content .right .ball .idx1>div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25%;
    margin-bottom: 5%
}

.lottery .lottery-content .right .ball .idx1>div.active p {
    background: #ff253f;
    color: #fff
}

.lottery .lottery-content .right .ball .idx1>div p {
    width: 3.33333rem;
    height: 3.33333rem;
    background: #fff;
    color: #7d7c7c;
    border-radius: 50%;
    font-size: 1.03333rem;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 .33333rem rgba(0,0,0,.04)
}

.popups {
    width: 90%;
    padding: 2.66667rem .66667rem 0;
    background: #e4e4e7;
    margin: .66667rem auto;
    border-radius: .33333rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative
}

.popups>p {
    position: absolute;
    font-weight: 600;
    font-size: .93333rem;
    top: .66667rem;
    left: .66667rem
}

.popups .ite {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 50%;
    padding-bottom: .66667rem
}

.popups .ite div {
    width: 3.33333rem;
    height: 3.33333rem;
    overflow: hidden;
    border-radius: .6rem
}

.popups .ite div img {
    width: 100%
}

.popups .ite p {
    font-size: .86667rem;
    padding: .66667rem 0
}

:export {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}

.ipt {
    padding: .33333rem;
    border: 1px solid #a253d0
}

.ipt::-moz-placeholder {
    font-size: .4rem
}

.ipt::placeholder {
    font-size: .4rem
}

.lottery2 {
    width: 10rem;
    height: 80%
}

.next .van-overlay {
    height: calc(100% - 44PX);
    top: auto;
    bottom: 0
}

.next .swiper {
    width: 100%;
    position: relative
}

.next .swiper .swiper-fot {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 2.66667rem;
    background: rgba(0,0,0,.9);
    border-radius: 1.66667rem 1.66667rem 0 0;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2% 0 5%
}

.next .swiper .swiper-fot .v {
    display: flex;
    justify-content: flex-end;
    align-items: center
}

.next .swiper .swiper-fot .v span {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg,#e7caaf,#fff7ed);
    color: #a4826b;
    font-weight: 600;
    margin-left: .2rem;
    padding: .2rem .6rem;
    font-size: 0.88rem;
}

.next .swiper .swiper-fot .v span:first-child {
    border-radius: 0 0 0 1rem
}

.next .swiper .swiper-fot .v span:last-child {
    border-radius: 0 1rem 0 0
}

.next .swiper .swiper-pagination {
    color: #fff;
    text-align: right;
    padding-right: .66667rem;
    bottom: 3.33333rem
}

.next .swiper .swiper-slide {
    height: 28rem;
    overflow: hidden;
    position: relative
}

.next .swiper .swiper-slide>span {
    position: absolute;
    z-index: 99;
    top: -5.33333rem;
    right: -8.66667rem;
    width: 10rem;
    height: 10rem;
    background: #ebcaaf;
    transform: rotate(45deg);
    opacity: .8
}

.next .swiper .swiper-slide>span i {
    position: absolute;
    bottom: 0;
    left: 1.83333rem;
    color: #8d684b;
    font-weight: 600
}

.next .swiper .swiper-slide img {
    width: 100%;
    display: block
}

.next .van-popup--center {
    right: 0;
    top: 44PX;
    left: auto;
    width: 120px;
    transform: none;
    background: linear-gradient(50deg,#822e84,#b63555);
    border-radius: 0 0 0 10px;
    color: #fff
}

.next .van-popup--center p {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0
}

.next .van-popup--center p:first-child {
    position: relative
}

.next .van-popup--center p img {
    width: 18px;
    margin-right: 10px
}

.next .jianjie {
    text-align: left;
    padding: 1rem 3%
}

.next .jianjie h2 {
    color: #2a1468;
    font-size: .93333rem
}

.next .jianjie p {
    padding: .66667rem 0;
    color: #534589
}

.next .foot {
    width: 100%;
    padding: .66667rem 3%
}

.next .foot h1 {
    text-align: left;
    color: rgba(0,0,0,.87);
    font-size: 1.06667rem;
    padding: .66667rem 0
}

.next .foot ul li {
    margin-top: .33333rem
}

.next .foot ul li img {
    width: 100%
}

.next .top {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 11.33333rem;
    background: red;
    overflow: hidden
}

.next .top img {
    width: 100%;
    display: block
}

.next .sm {
    display: flex;
    text-align: left;
    width: 100%;
    margin: 0 auto;
    padding: .33333rem 3%;
    position: relative
}

.next .sm>a {
    position: absolute;
    right: 1.66667rem;
    bottom: .66667rem;
    color: #fff;
    padding: .33333rem 1rem;
    background: linear-gradient(20deg,#e73266,#ee5380);
    border-radius: .33333rem
}

.next .sm .right {
    position: absolute;
    display: none;
    right: 1.66667rem;
    text-align: center;
    color: #333
}

.next .sm .right img {
    width: 3.66667rem;
    display: block
}

.next .sm .lef {
    max-width: 100%
}

.next .sm .lef .jg {
    padding: .66667rem 0
}

.next .sm .lef .jg>h3 {
    color: #666;
    font-size: .83333rem;
    font-weight: 400;
    padding-top: .66667rem
}

.next .sm .lef .jg>h3 span {
    padding-left: 1rem
}

.next .sm .lef .jg p {
    color: #ff207d;
    font-size: 1rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end
}

.next .sm .lef .jg p span {
    color: #666;
    font-size: .76667rem;
    text-decoration: line-through!important;
    margin-left: .66667rem;
    display: inline-block
}

.next .sm .lef> {
    margin: .33333rem 0
}

.next .sm .lef h2 {
    font-size: 1rem;
    color: #f2b247;
    font-weight: 400
}

.next .sm .lef h1 {
    color: #000;
    font-size: 1.06667rem
}

.next .sm .lef h1 span {
    font-size: .93333rem;
    color: #f2b247;
    font-weight: 400
}

.next .sm .lef p {
    font-size: .83333rem;
    color: #333
}

.next .sm .lef p img {
    height: .86667rem
}

.next .sm .lef .sf {
    display: flex;
    justify-content: flex-start;
    align-items: center
}

.next .sm .lef .sf i,.next .sm .lef .sf span {
    width: 1rem;
    height: 1rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABl0lEQVRIie3WMUhVURzH8c97WQg6VJIICeLUENIgDa+GmnSQCCKIHINqCkRoKWiwRVtcogjMzcVJHWrt4RBOWWu4iLW0NIRD8cjh3IeHy70+37vvbv7gDPd//ud+/3/O+f/Pqfz5eE8Heoo1fG93YbUD2CXM4XUHa9sGVvAOvZjA3bKBD3Aj+l5Ef1nAQbxK2YbxoizgIs5n2GdwudvASUznzJ0WDlClG8AqxvCmhd9NPMKpVsBKqg77cBXXUcM1nGv1k0i/sYlPqGMbjdihB7eTCGsYT2yd6ixuJSMOoJ4Esd2DAWHjy1AcwC/UqljGQknApvYT6E7z0DzHRkmwBu5ji8NT2jR+KwH4RJRMXBb7mMLPLsLm8TY2pOtwD3cSeFGt4FnamFX4W0IRF9Gm0Oj/HwcIXwoCP+Bv1kQecKggMKvJHwm8UBCY2w5PMszSrnAZH9Uk2gamM2xgXWgMo5jFFeGWWcW/lP9AHjDvKmpmuIslvJfdgerJuIjHeJisbXsPPzvM5mUOLNYP4TE1IjxFvuJMluMB65BGG6uhkFoAAAAASUVORK5CYII=) no-repeat 50%/100%
}

.next .sm .lef .sf i {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAACXBIWXMAAAsTAAALEwEAmpwYAAABd0lEQVRIic3VX0tUQRjH8Y/LhoneRCKZWkQlIZKKN4qguG+i1+ilEAkSdFUhghdhN10sQimLCgmuiCCsFzsHj6dzlt3zB/rBwJln5nm+88yZZ2aovfNBDi2jib+DOtZywJ5gFZs5fHMBG6jjBWarBs5hJtZfx6OqgCMBENcYVqoCbuBxin0JT8sGvsS7HjEaZQGHMN5HwCm8D/N7qp7Sf4bnmAwtbRvT1MAaTvAHv3GGThLwGtMh+IR8pRJpGK9Cg5vkAuohg6UCkH4XcI2tGn5ivyJgpFts4yLavm+6d2MV6uATWtz/r8h4VgHwi1gy8QMSpd0uEbaPH3FD8kS28THAi+oXviaNaSXQwueCsBZ20wayau60ILApY5eygKMFgcNZA1nAfq+zLGX6/zcZjhQElprhJQ5wngeYfJ4iJTPs6J68Qxy5f3KmsIA3Hi5+YGCU4WWAHOIqZd5xaKO6D/B8+B4Y2MKeh9n00hW+B5+3WAyx/6nFOy/YRbaXhyhbAAAAAElFTkSuQmCC) no-repeat 50%/100%
}

.next .sm .lef .tips {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 0
}

.next .sm .lef .tips span {
    background: linear-gradient(30deg,#7d76ef,#d63f8c);
    color: #fff;
    display: inline-block;
    border-radius: .33333rem;
    margin-right: .33333rem;
    font-size: 12PX;
    padding: .33333rem 1rem;
    margin-bottom: .33333rem
}
.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 24px;
}

.poster {
    height: 13.33333rem;
    background: #000;
    position: relative
}

.poster>div,.poster {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center
}

.poster>div {
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.8)
}

.poster>div .van-loading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center
}

.poster img {
    height: 100%
}
</style>
